<template>
  <Dialog
    ref="dialog"
    :title="$t('title.agency.agencyConnectionUpdateConfirm')"
    width="600"
    max-width="600"
    :color="'next'"
  >
    <v-container>
      <v-layout column wrap>
        <v-row>
          <v-col>
            <div class="text-center" style="margin: 0 auto;">
              <p v-if="isRegister">
                {{ $t('description.confirmRegisterAgencyConnection') }}
              </p>
              <p v-else>
                {{ $t('description.confirmDeleteAgencyConnection') }}
              </p>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card>
              <v-card-actions>
                <AgencySearchList
                  :records="agencies"
                  :subheader1="$t('label.subheader.agencyCode')"
                  :subheader2="$t('label.subheader.agencyName')"
                  :subheader3="$t('label.subheader.salesCode')"
                >
                </AgencySearchList>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-layout>
    </v-container>

    <template v-slot:footer>
      <v-btn width="33%" class="back" dark @click="close()">{{
        $t('button.close')
      }}</v-btn>
      <v-btn width="33%" class="next" dark @click="onClickUpdateButton()">
        {{ $t('button.update') }}
      </v-btn>
    </template>
    <ErrorDialog ref="errorDialog"></ErrorDialog>
  </Dialog>
</template>

<script>
import AgencySearchList from '@/components/organisms/agency/AgencySearchList';
import Dialog from '@/components/organisms/agency/Dialog';
import ErrorDialog from '@/components/organisms/agency/ErrorDialog';

export default {
  components: { Dialog, ErrorDialog, AgencySearchList },
  props: {
    // 登録用のダイアログであるかどうか
    isRegister: Boolean,
  },
  data() {
    return {
      // 営業店ID
      salesId: null,

      // 代理店
      agencies: [],
    };
  },
  methods: {
    open() {
      this.$refs.dialog.open();
    },
    close() {
      this.$refs.dialog.close();
    },
    set(salesId, agencies) {
      this.$set(this, 'salesId', salesId);
      this.$set(this, 'agencies', agencies);
    },
    onClickUpdateButton(agencies) {
      const agencyIds = this.agencies.map(agency => agency.id);
      this.$emit('onSuccess', agencyIds);
    },
  },
};
</script>
